import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "visual-facade",
  "aria-hidden": "true"
}
const _hoisted_2 = ["value", "min", "aria-label"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'NextDrawsFilter' },
  __name: 'NextDrawsFilter',
  props: {
    modelValue: { default: () => new Date().toISOString().split('T')[0] },
    allowPast: { type: Boolean, default: false },
    placeholder: { default: '' },
    fallbackToToday: { type: Boolean, default: true },
    noInteractionHighlight: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const hasSelectedDate = computed(() => Boolean(props.modelValue?.trim()));

const today = new Date().toISOString().split('T')[0];

const emit = __emit;

const displayDate = computed(() => {
  if (!props.modelValue) return '';
  const parts = props.modelValue.split('-').map(Number);
  if (parts.length === 3 && parts.every((n) => Number.isFinite(n))) {
    const [y, m, d] = parts;
    const date = new Date(y, m - 1, d);
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
  return props.modelValue;
});

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const next = target.value || (props.fallbackToToday ? today : '');
  emit('update:modelValue', next);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["next-draws-filter", {
      'next-draws-filter--static': _ctx.noInteractionHighlight,
      'next-draws-filter--has-date': hasSelectedDate.value,
    }]),
    role: "group"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["display-date", { 'display-date--placeholder': !hasSelectedDate.value }])
      }, _toDisplayString(hasSelectedDate.value ? displayDate.value : _ctx.placeholder), 3),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "calendar-icon",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", { d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM7 12h5v5H7v-5z" })
      ], -1))
    ]),
    _createElementVNode("input", {
      type: "date",
      class: "native-date-input",
      value: _ctx.modelValue,
      min: _ctx.allowPast ? undefined : _unref(today),
      "aria-label": displayDate.value || 'Select date',
      onChange: handleInput,
      onInput: handleInput
    }, null, 40, _hoisted_2)
  ], 2))
}
}

})